// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */

.CitySection-categoryBgWrapper-tPKYA {
    padding: 90px 0;
}

.CitySection-categorySliderHeading-uUNAj {
    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    color: var(--primary-foreground);
    word-break: break-word;
    margin-bottom: 48px;
    text-align: center;
}

.CitySection-viewAllLinkContainer-aCuDn {
    margin-top: 30px;
    text-align: center;
}

@media (max-width: 767px) {
    .CitySection-categorySliderHeading-uUNAj {
        font-size: 24px;
        line-height: 34px;
        margin-bottom: 30px;
    }

    .CitySection-categoryBgWrapper-tPKYA {
        padding: 48px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/CitySection/CitySection.css"],"names":[],"mappings":"AAAA,QAAQ;;AAER;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* new */\n\n.categoryBgWrapper {\n    padding: 90px 0;\n}\n\n.categorySliderHeading {\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 50px;\n    color: var(--primary-foreground);\n    word-break: break-word;\n    margin-bottom: 48px;\n    text-align: center;\n}\n\n.viewAllLinkContainer {\n    margin-top: 30px;\n    text-align: center;\n}\n\n@media (max-width: 767px) {\n    .categorySliderHeading {\n        font-size: 24px;\n        line-height: 34px;\n        margin-bottom: 30px;\n    }\n\n    .categoryBgWrapper {\n        padding: 48px 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryBgWrapper": `CitySection-categoryBgWrapper-tPKYA`,
	"categorySliderHeading": `CitySection-categorySliderHeading-uUNAj`,
	"viewAllLinkContainer": `CitySection-viewAllLinkContainer-aCuDn`
};
module.exports = ___CSS_LOADER_EXPORT___;
